var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}],staticClass:"ccui-app-main"},[_c('router-view',{key:_vm.key})],1)}
var staticRenderFns = []

export { render, staticRenderFns }